import { render, staticRenderFns } from "./AdministrationConfirmation.vue?vue&type=template&id=93034628&scoped=true"
import script from "./AdministrationConfirmation.vue?vue&type=script&lang=js"
export * from "./AdministrationConfirmation.vue?vue&type=script&lang=js"
import style0 from "./AdministrationConfirmation.vue?vue&type=style&index=0&id=93034628&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93034628",
  null
  
)

export default component.exports